import { useControlledSwr } from '@systemeio/util'
import { digitalProductRevalidationKeys } from 'modules/digital-product/constants/digital-product-dependencies'
import { FUNNELS_API } from 'modules/funnels/api/funnels-api'
import { OfferFormViewInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/offer-form-interface'
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useMutationUpdate } from 'shared/hooks/use-mutation-update'
import useUser from 'shared/hooks/use-user'

const getOfferSettingsSwrKey = (id: FunnelStepId) => [
  `${FUNNELS_API}/steps/${id}/offer-form`,
  ...digitalProductRevalidationKeys,
  RequestModuleEnum.PhysicalProducts,
  RequestModuleEnum.Coupons,
]

export function useOfferFormSettings(id: FunnelStepId) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, OfferFormViewInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: offerFormSettings, mutate: mutateOfferFormSettings } = useControlledSwr(
    () => user && getOfferSettingsSwrKey(id),
    fetcher,
  )

  return { offerFormSettings, mutateOfferFormSettings }
}

export const useOfferFormSettingsMutation = () => {
  const mutate = useMutationUpdate()

  const clearCurrencyRelatedFields = async (funnelStepIds?: number[]) => {
    if (!funnelStepIds) return
    for await (const id of funnelStepIds) {
      await mutate<OfferFormViewInterface>(
        getOfferSettingsSwrKey(id),
        data =>
          data && {
            ...data,
            offer: { ...data.offer, bumps: [], coupons: [], product: null, digitalProduct: null },
          },
      )
    }
  }

  return { clearCurrencyRelatedFields }
}
